import { useCreateAudit } from '@cdab/scania/qpr/hooks'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsToast } from '@scania/tegel-react'
import { forwardRef, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import type {
  CreateAuditModalProps,
  ParsedAuditData
} from './audit-modal.types'
import { AuditModal } from './common-audit-modal'

export const AuditCreateModal = forwardRef<
  HTMLTdsModalElement,
  CreateAuditModalProps
>(function AuditCreateModal(props, ref) {
  const { dealerId, onClose, onSubmit } = props
  const [createAudit, createState] = useCreateAudit()
  const auditIdRef = useRef<number | undefined>(undefined)
  const [t] = useTranslation()

  const handleSubmit = async (data: ParsedAuditData) => {
    auditIdRef.current = await createAudit({
      dealerId: dealerId,
      description: data.description || '',
      extraAuditors: data.extraAuditor || '',
      date: data.date,
      auditTypeId: data.auditTypeId
    })

    if (auditIdRef.current !== undefined) {
      toast(
        <TdsToast
          variant='success'
          header={capitalizeFirstLetter(t('audit-created'))}
          subheader={capitalizeFirstLetter(t('audit-created-success'))}
        />
      )
      onSubmit(auditIdRef.current)
      return true
    }

    return false
  }

  return (
    <AuditModal
      ref={ref}
      initialAuditTypeId={1} // If no audit type is provided, default is Certification audit and hence id 1
      header={t('create-audit')}
      disableSave={createState.state === 'loading'}
      onSubmit={handleSubmit}
      onClose={onClose}
      errorMessage={
        createState.state === 'error' ? createState.error : undefined
      }
    />
  )
})
